import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ViewDetailsModal } from '../../../modals/view-details-modal/view-details-modal.component';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal } from '@app/shared/modals';
import { EditSubtopicModal } from '../../../modals/edit-subtopic-modal/edit-subtopic-modal.component';
import { AssignSubtopicModal } from '../../../modals/assign-subtopic-modal/assign-subtopic-modal.component';
import { ChatService } from 'src/modules/features/admin/services';

@Component({
  selector: 'app-chat-topic',
  templateUrl: './chat-topic.component.html',
  styleUrls: ['./chat-topic.component.scss'],
})
export class ChatTopicComponent implements OnInit {
  @Input() topic: {
    topic: string;
    topicId: string;
    dateCreated: string;
    createdBy: string;
    subtopicList: {
      subtopic: string;
      dateCreated: string;
      createdBy: string;
      topic: string;
    }[];
  };

  @Input() disabled: boolean;
  @Input() activatedSubtopicId: string;
  @Input() activatedTopic: string;
  @Output()
  onEdit = new EventEmitter();
  @Output() onView = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Output() onAdd = new EventEmitter();
  @Output() onRefresh = new EventEmitter<string>();

  @Output() onActivate = new EventEmitter();
  @Output() assignSubtopicToUser = new EventEmitter();
  @Input() isSelected: any;

  collapseTopic: boolean = true;
  pending: boolean = false;

  selectedSubtopic;
  activeTopic;

  constructor(
    private router: Router,
    private modalService: SuiModalService,
    private chatService: ChatService
  ) {}

  ngOnInit(): void {
    console.log(this.activatedTopic);
    if (this.activatedTopic === this.topic.topicId) {
      this.collapseTopic = !this.collapseTopic;
    }
  }

  toggleSubtopic() {
    this.collapseTopic = !this.collapseTopic;
    if (this.collapseTopic == false) {
      //Get subtopics from topic id
    }
  }

  loadUsersScreen(item, i) {
    //navigate to url
    this.router.navigate(['/admin/setting/chat-config'], {
      queryParams: {
        subtopicId: item.subtopicId,
      },
    });
    this.selectedSubtopic = this.topic.subtopicList[i];
    this.activeTopic = this.topic.topic;
    console.log(this.selectedSubtopic);
  }

  editSubtopic(item, topic) {
    this.modalService
      .open(new EditSubtopicModal('Edit Sub-topic', item, topic))
      .onApprove((value: any) => {
        this.onRefresh.emit('Subtopic updated successfully');
        // update ui
        // get topic data
      })
      .onDeny(() => {
        // do nothing
      });
  }

  viewSubtopic(item, topic) {
    this.modalService
      .open(
        new ViewDetailsModal(
          'View Sub-topic Details',
          Object.assign(item, topic)
        )
      )
      .onApprove((value: any) => {})
      .onDeny(() => {
        // do nothing
      });
  }

  deleteSubtopic(item) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Sub-topic',
          'Are you sure you want to delete this sub-topic?',
          ModalSize.Small,
          'Delete',
          'Cancel'
        )
      )
      .onApprove((value: any) => {
        this.pending = true;
        this.chatService
          .deleteSubTopic({ subtopicId: item.subtopicId })
          .subscribe(
            (response) => {
              this.onRefresh.emit('Subtopic deleted successfully');
            },
            (error) => {}
          );
        // update ui
        // get topic data
      })
      .onDeny(() => {
        // do nothing
      });
  }
}
